import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {NotificationService} from "./notification.service";
import {LoggingService} from "./logging.service";
import {ErrorService} from "./error.service";

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) {
  }

  handleError(error: any): void {
    const errorService = this.injector.get(ErrorService);
    const logger = this.injector.get(LoggingService);
    const notifier = this.injector.get(NotificationService);

    let message: string | null;
    let stackTrace;
    if (error instanceof HttpErrorResponse) {
      // Server Error
      message = errorService.getServerMessage(error);
      stackTrace = errorService.getServerStack(error);
    } else if (error instanceof ErrorEvent) {
      let httpErrorFromEvent = error.error;
      try {
        httpErrorFromEvent.error = JSON.parse(error.error.error) // needed because client stringifies it
      }catch (e) {
        //not needed
      }
      this.handleError(httpErrorFromEvent);
      return;
    } else {
      // Client Error
      message = errorService.getClientMessage(error);
      stackTrace = errorService.getClientStack(error);
    }
    if (message) {
      notifier.showError(message);
    } else {
      message = '';
    }

    // Always log errors
    logger.logError(message, stackTrace);
    console.error(error);
  }
}
